<template>
  <div id="who-i-am">
    <ParallaxFade>
      <span slot="tagline-left">WHO I AM</span>
      <h1 slot="heading">
        I'm
        <vue-typer
          class="no-wrap"
          ref="vueTyper"
          :text="[
            'an interactive designer',
            'a digital strategist',
            'a frontend developer'
          ]"
          :repeat="Infinity"
          :shuffle="true"
          initial-action="erasing"
          :pre-type-delay="70"
          :type-delay="70"
          :pre-erase-delay="2000"
          :erase-delay="250"
          erase-style="select-all"
          :erase-on-complete="false"
          caret-animation="smooth"
        ></vue-typer
        ><br />
        focused on crafting <span class="highlight">amazing</span> user
        <span class="highlight">experiences...</span>
      </h1>
      <router-link to="/projects" class="h3 main-button" tag="a" slot="link"
        >see my work</router-link
      >
    </ParallaxFade>

    <aside
      :style="{
        opacity: `${0.1 - scrollPos / 4000}`
      }"
      class="image"
      v-for="n in 3"
      :key="n"
    ></aside>
  </div>
</template>

<script>
import ParallaxFade from "@/components/ParallaxFade";
export default {
  components: {
    ParallaxFade
  },
  data() {
    return {
      scrollPos: 0,
      scrollingAnimation: null
    };
  },
  methods: {
    scrollBanner() {
      window.addEventListener(
        "scroll",
        (this.scrollingAnimation = () => {
          this.scrollPos = document.scrollingElement.scrollTop;
        })
      );
    }
  },
  mounted() {
    this.scrollBanner();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollingAnimation);
  }
};
</script>

<style lang="scss" scoped>
.no-wrap {
  white-space: normal;

  @media (min-width: 500px) {
    white-space: nowrap;
  }
}

#who-i-am {
  overflow-x: hidden;
  position: relative;
  width: 100vw;
  max-width: 100vw;
}

.image {
  width: 300px;
  height: 300px;
  background-size: cover;
  position: fixed;
  transition: 0.3s all ease;
  z-index: 0;

  &:first-of-type {
    top: -150px;
    left: 50%;
    background-image: url(../assets/img/ui.jpg);
  }

  &:nth-of-type(2) {
    top: 450px;
    left: 75%;
    background-image: url(../assets/img/girl-moon.jpg);
  }

  &:nth-of-type(3) {
    left: 5%;
    top: 647px;
    top: 647px;
    background-image: url(../assets/img/floating.jpg);
  }
}

/deep/ .vue-typer {
  color: #ffff;

  .custom.char {
    &.typed {
      color: $primary;
    }

    &.selected {
      background-color: #009688;
    }
  }
}
</style>
